import request from '@/plugins/request';
import { IBoolResult, IStringResult } from '@/types/dto';
import { INode } from '@/types/models';
import utils from '@/utils';
import { AxiosResponse } from 'axios';

const $url = '/admin/nodes';
const $urlShell = '/admin/nodes/actions/shell';
const $urlReboot = '/admin/nodes/actions/reboot';
const $urlReload = '/admin/nodes/actions/reload';
const $urlAssistant = '/admin/nodes/actions/assistant';
const $urlUpdateImage = '/admin/nodes/actions/updateImage';
const $urlUpdateCert = '/admin/nodes/actions/updateCert';

interface IGetResult {
  items: INode[];
}

export interface IShellResult {
  ftp: string;
  docker: string;
  nginx: string;
}

interface IAssistantRequest {
  nodeId: number;
  command: string;
}

interface IUpdateImageRequest {
  nodeId: number;
  version: string;
}

export default {
  get(success: (res: IGetResult) => void) {
    utils.loading(true);
    request
      .get($url)
      .then((response: AxiosResponse<IGetResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  submit(req: INode, success: (res: IBoolResult) => void) {
    utils.loading(true);
    request
      .post($url, req)
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  shell(nodeId: number, success: (res: IShellResult) => void) {
    utils.loading(true);
    request
      .post($urlShell, {
        nodeId,
      })
      .then((response: AxiosResponse<IShellResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  updateCert(nodeId: number, success: (res: IBoolResult) => void) {
    utils.loading(true);
    request
      .post($urlUpdateCert, {
        nodeId,
      })
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  reboot(nodeId: number, success: (res: IBoolResult) => void) {
    utils.loading(true);
    request
      .post($urlReboot, {
        nodeId,
      })
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  reload(nodeId: number, success: (res: IBoolResult) => void) {
    utils.loading(true);
    request
      .post($urlReload, {
        nodeId,
      })
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  delete(nodeId: number, success: (res: IBoolResult) => void) {
    utils.loading(true);
    request
      .delete($url, {
        data: {
          nodeId,
        },
      })
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  assistant(req: IAssistantRequest, success: (res: IStringResult) => void) {
    utils.loading(true);
    request
      .post($urlAssistant, req)
      .then((response: AxiosResponse<IStringResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  updateImage(req: IUpdateImageRequest, success: (res: IBoolResult) => void) {
    utils.loading(true);
    request
      .post($urlUpdateImage, req)
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },
};
